import { Directive, HostListener } from '@angular/core';
import { NgModel } from '@angular/forms';
import { MaskedInputDirective } from 'angular2-text-mask';

@Directive({
  selector: '[cmInputCpf]',
  providers: [NgModel, MaskedInputDirective],
})
export class InputCpfDirective {
  @HostListener('input')
  input() {}
}
